<template>
  <div class="row">
    <div class="col-12">
      <b-img
        :src="`/images/course/quotemark_${isDarkBg ? 'white' : 'blue'}_up.svg`"
        style="width: 50px"
      ></b-img>
    </div>
    <div class="col-12 py-3">
      <p
        class="font-italic text-center text"
        :class="{ 'color-white': isDarkBg }"
        v-html="quoteText"
      ></p>
    </div>
    <div class="col-12 d-flex justify-content-end">
      <b-img
        :src="`/images/course/quotemark_${isDarkBg ? 'white' : 'blue'}_down.svg`"
        style="width: 50px"
      />
    </div>
    <div class="col-12 d-flex align-items-center flex-column text-center pt-3">
      <b-img :src="quoteImage" style="width: 32px" v-if="quoteImage" />
      <small class="font-weight-bold mt-2 mb-0" v-if="quoteName">{{ quoteName }}</small>
      <small v-if="quoteDetail">{{ quoteDetail }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "Quote",
  props: {
    quoteImage: String,
    quoteText: String,
    quoteName: String,
    quoteDetail: String,
    isDarkBg: Boolean,
  },
};
</script>

<style scoped lang="scss">
.text {
  font-size: 20px;
  line-height: 38px;
  font-family: $font-family-monospace;
  color: $color-blue;
  &.color-white {
    color: $color-white;
  }
}
@media (max-width: 768px) {
  .text {
    font-size: 16px;
    line-height: 30px;
  }
}
</style>
